import { render, staticRenderFns } from "./DocumentsFollowup.vue?vue&type=template&id=4466c74c"
import script from "./DocumentsFollowup.vue?vue&type=script&lang=js"
export * from "./DocumentsFollowup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports